// extracted by mini-css-extract-plugin
export var fadeInOut = "_3s-3";
export var icon = "_3s-4";
export var savedIndicator = "_3s-2";
export var savingIndicator = "_3s-0";
export var spin = "_3s-1";